import { PaginacionProps } from "../global/PaginacionInterface";
import { ExpedienteProps, defaultExpediente } from "../recepcion/ExpedienteInterface";

export const defaultBuscarLibroMedioImpugnacionResponse: LibroMedioImpugnacionResponse = { currentPageIndex: 0, pageCount: 0, recordCount: 0, records: [], };

export const defaultBuscarLibroMedioImpugnacion: BuscarLibroMedioImpugnacion = { idAutoridad: 0, numeroReferencia: '' };

export const defaultLibroMedioImpugnacion: LibroMedioImpugnacionProps = { 
    idLibroMedioImpugnacion:        0,
    idExpediente:                   0,
    numeroExpediente:               '',
    idMedioImpugnacion:             0,
    observaciones:                  '',
    recurrente:                     '',
    tipoRecurso:                    '',
    tipoResolucion:                 '',
    sentido:                        '',
    expediente:                     defaultExpediente,
};

export interface LibroMedioImpugnacionProps {
    idLibroMedioImpugnacion:        number;
    idExpediente:                   number;
    numeroExpediente:               string;
    idMedioImpugnacion:             number;
    observaciones:                  string;
    fechaRecepcion?:                Date;
    recurrente:                     string;
    tipoRecurso:                    string;
    tipoResolucion:                 string;
    sentido:                        string;
    fechaResolucion?:               Date;
    fechaAdmision?:                 Date;
    fechaRemisionAlzada?:           Date;
    fechaDevolucionAlzada?:         Date;
    expediente:                     ExpedienteProps;
}

export interface BuscarLibroMedioImpugnacion {
    idAutoridad:        number;
    numeroReferencia:   string;
}

export interface BuscarLibroMedioImpugnacionParams extends PaginacionProps, BuscarLibroMedioImpugnacion { }

export interface LibroMedioImpugnacionResponse {
    currentPageIndex:   number;
    pageCount:          number;
    recordCount:        number;
    records:            LibroMedioImpugnacionProps[];
}

export interface GuardarObservaciones {
    id:             number;
    observaciones:  string;
}

export interface DescargarInformacionParams { 
    idAutoridad:        number;
    numeroReferencia:   string;
}